// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Filtering from "../RuleCatalogue/Filtering";
// import KpiCard from "../RuleCatalogue/KpiCard";
// import Tables from "../RuleCatalogue/Tables";
// import heartLoading from "../../assests/heartLoading.gif";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const SavedRuleCatalogue = ({
//   dashboardId = null,
//   currentFilters = {},
//   onFiltersChange,
//   searchTerm = "",
//   onSearchChange,
// }) => {
//   const [page, setPage] = useState(1);
//   const [ruleData, setRuleData] = useState(null);
//   const BASE_URL = process.env.REACT_APP_API_URL;

//   // ✅ Export to Excel for saved dashboard
//   const exportToExcel = (data) => {
//     if (!data || data.length === 0) return;

//     const ws = XLSX.utils.json_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Rules");

//     const filename = `SavedDashboard_${dashboardId}.xlsx`;
//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(blob, filename);
//   };

//   const handleExport = () => {
//     if (!dashboardId) return;
//     axios
//       .get(`${BASE_URL}/view-rule-catalouge/${dashboardId}?page=1&pageSize=10000`)
//       .then((res) => {
//         exportToExcel(res.data.tableData || []);
//       })
//       .catch((err) => console.error("Error exporting saved data:", err));
//   };

//   // ✅ Data fetch (GET for saved dashboard)
//   useEffect(() => {
//     if (!dashboardId) return;

//     axios
//       .get(`${BASE_URL}/view-rule-catalouge/${dashboardId}?page=${page}&pageSize=10`)
//       .then((res) => {
//         setRuleData(res.data);

//         // Sync filters/searchTerm from response
//         if (res.data.filters) onFiltersChange(res.data.filters);
//         if (res.data.search_term) onSearchChange(res.data.search_term);
//       })
//       .catch((err) => console.error("Error fetching saved rule catalogue:", err));
//   }, [dashboardId, page, BASE_URL, onFiltersChange, onSearchChange]);

//   if (!ruleData) {
//     return (
//       <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
//         <div className="flex flex-col items-center space-y-3">
//           <img src={heartLoading} alt="Loading..." className="h-30" />
//           <span className="text-gray-700 text-[20px]">
//             Hang tight! The resources are loading...
//           </span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="rule-catalogue">
//       <Filtering
//         availableFilters={ruleData.filters}
//         currentFilters={currentFilters}
//         onFiltersChange={onFiltersChange}
//         showSearch={true}
//         searchTerm={searchTerm}
//         onSearchChange={onSearchChange}
//         disabled={true} 
//       />
//       <KpiCard rules={ruleData.rules} />
//       <Tables
//         tableData={ruleData.tableData}
//         pagination={ruleData.pagination}
//         onPageChange={setPage}
//         onExport={handleExport}
//       />
//     </div>
//   );
// };

// export default SavedRuleCatalogue;
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Filtering from "../RuleCatalogue/Filtering";
import KpiCard from "../RuleCatalogue/KpiCard";
import Tables from "../RuleCatalogue/Tables";
import heartLoading from "../../assests/heartLoading.gif";
import preloader from "../../assests/preloader1.gif";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const SavedRuleCatalogue = ({
  dashboardId = null,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
}) => {
  const [page, setPage] = useState(1);
  const [ruleData, setRuleData] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const initialLoaded = useRef(false);

  // ✅ Export to Excel for saved dashboard
  const exportToExcel = (data) => {
    if (!data || data.length === 0) return;

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rules");

    const filename = `SavedDashboard_${dashboardId}.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, filename);
  };

  const handleExport = () => {
    if (!dashboardId) return;
    axios
      .get(`${BASE_URL}/view-rule-catalouge/${dashboardId}?page=1&pageSize=10000`)
      .then((res) => {
        exportToExcel(res.data.tableData || []);
      })
      .catch((err) => console.error("Error exporting saved data:", err));
  };

  // ✅ Data fetch (GET for saved dashboard)
  useEffect(() => {
    if (!dashboardId) return;

    axios
      .get(`${BASE_URL}/view-rule-catalouge/${dashboardId}?page=${page}&pageSize=10`)
      .then((res) => {
        setRuleData(res.data);

        // Sync filters/searchTerm only on first load
        if (!initialLoaded.current) {
          if (res.data.filters) onFiltersChange(res.data.filters);
          if (res.data.search_term) onSearchChange(res.data.search_term);
          initialLoaded.current = true;
        }
      })
      .catch((err) => console.error("Error fetching saved rule catalogue:", err));
  }, [dashboardId, page, BASE_URL]); // ⛔ removed onFiltersChange & onSearchChange

  if (!ruleData) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
        <div className="flex flex-col items-center space-y-3">
          <img src={preloader} alt="Loading..." width={200} />
          <span className="text-gray-700 text-[20px]">
            Hang tight! The resources are loading...
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="rule-catalogue">
      <Filtering
        availableFilters={ruleData.filters}
        currentFilters={currentFilters}
        onFiltersChange={onFiltersChange}
        showSearch={true}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        disabled={true} 
      />
      <KpiCard rules={ruleData.rules} />
      <Tables
        tableData={ruleData.tableData}
        pagination={ruleData.pagination}
        onPageChange={setPage}
        onExport={handleExport}
      />
    </div>
  );
};

export default SavedRuleCatalogue;
